import { render } from "./WCActiveOrderTypeBadge.vue?vue&type=template&id=47ea1f00&ts=true"
import script from "./WCActiveOrderTypeBadge.vue?vue&type=script&lang=ts"
export * from "./WCActiveOrderTypeBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__